module.exports = __webpack_public_path__ + "img/Picture10.c702473a.png";